import debounce from 'lodash.debounce';
import SVGInjector from 'svg-injector';

import '../scss/style.scss';

import Tabs from './components/tabs.js'
import Labels from './components/labels.js'
import HideShow from './components/hide-show.js'
import Modal from './components/modal.js'
import Forms from './components/form-submission.js'

import watchForFormDependancies from './components/form-dependancies.js'
import iOSRecaptcha from './components/form-ios-captcha.js'

const responsiveFunctions = () => {
  Modal.init();

  if (window.innerWidth < 1024) {
    Tabs.init();
  } else {
    Tabs.destroy();
  }
}

window.onReCaptchaSuccess = iOSRecaptcha.onReCaptchaSuccess;

window.addEventListener('load', () => {
  const activeNavItem = document.querySelector(`.c-nav-link[href$="${location.pathname.split("/")[1]}"]`);

  if (activeNavItem) {
    activeNavItem.setAttribute('aria-current', 'page');
  }

  responsiveFunctions();
  watchForFormDependancies();

  iOSRecaptcha.init();
  Labels.init();
  HideShow.init();
  // getPickupsByEmail.init();
  Forms.init();

  if (document.querySelector('img.is-svg')) {
    var SVGsToInject = document.querySelectorAll('img.is-svg');
    SVGInjector(SVGsToInject);
  }

});

window.addEventListener('resize', debounce(() => {
  responsiveFunctions();
}, 150));
  
// window.dispatchEvent(new Event('resize'));



// WEBPACK FOOTER //
// ./src/js/app.js